import { FileReader, FileWriter } from '@/platform'
import Var from './Var'
import ModuleId from './DataStructModuleId'

class GameVar {
    public mid = ModuleId.gameVar
    public Data: Var[] = []
    constructor(isEx: boolean = false) {
        this.Data = []
        if (isEx) {
            this.dataInitEX()
        } else {
            this.dataInit()
        }
    }

    dataInitEX() {
        this.mid = ModuleId.gameVarEx
        this.Data.push(new Var(0, '通关次数'))
        this.Data.push(new Var(0, ''))
        for (let i: number = 0; i < 98; i++) {
            this.Data.push(new Var(0, ''))
        }
    }

    dataInit() {
        this.Data.push(new Var(0, '与橙娘的好感度'))
        this.Data.push(new Var(0, ''))
        for (let i: number = 0; i < 98; i++) {
            this.Data.push(new Var(0, ''))
        }
    }

    readBin(reader: FileReader): void {
        this.Data = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let v = new Var()
            v.readBin(reader)
            this.Data.push(v)
        }
    }

    writeBin(writer: FileWriter,): void {
        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            var val = this.Data[i]
            if (val instanceof Var === false) {
                val = Object.assign(new Var(), val)
            }
            val.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.Data = []
        const len = reader.readInt()

        for (var i = 0; i < len; i++) {
            let v = new Var()
            v.readVersionedOui(reader.readObj(reader.readInt()))
            this.Data.push(v)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            let v = this.Data[i]
            if (v instanceof Var === false) {
                v = Object.assign(new Var(), v)
            }
            v.writeVersionedOui(writer)
        }

        writer.writerLength()
    }
}

export default GameVar
